import React, { useEffect, useState } from "react";
import { cn } from "../utils";
import { Spinner } from "./Spinner";

/**
 * Appears once `active` has been true for `delay` ms and offers Cancel
 * when the caller can actually abort the request.
 */
export function SlowLoadNotice({
  active,
  onCancel,
  message = "Still loading. A long date range can take a little longer.",
  delay = 4000,
  className,
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!active) {
      setVisible(false);
      return undefined;
    }
    const t = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(t);
  }, [active, delay]);

  if (!active || !visible) return null;

  return (
    <div
      className={cn(
        "aone-fade-in flex items-center gap-2 px-3 py-[9px] border border-solid border-gray-200 rounded-lg bg-gray-50 text-xs text-gray-700",
        className
      )}
    >
      <Spinner />
      <span className="flex-1 min-w-0">{message}</span>
      {onCancel && (
        <button
          type="button"
          onClick={onCancel}
          className="text-xs font-medium text-[#EC171C] bg-transparent border-0 p-0 rounded hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#EC171C]/40"
        >
          Cancel
        </button>
      )}
    </div>
  );
}

export default SlowLoadNotice;
